import { css, media, styled } from '@nx-kit/styling';
import Link from 'components/atoms/Link/Link';

export const LinkStyled = styled(Link)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  ${media('md')} {
    width: fit-content;
  }
`;
export const PdfContentStyled = styled.div`
  display: none;
`;

export const pdfCss = css`
  @media print {
    body {
      font-family: Arial, Helvetica, sans-serif;
      padding: 0;
      margin: 0;
    }

    .logo-wrapper {
      position: fixed;
      top: 0;
      right: 25mm;
      width: 40mm;
    }

    h1 {
      display: block;
      width: 100%;
      font-size: 6mm;
      padding-bottom: 3mm;
    }

    table {
      table-layout: fixed;
      width: 16cm;
      margin-bottom: 5mm;
    }

    th,
    td {
      text-align: left;
    }

    th:first-of-type,
    th:last-of-type td:first-of-type,
    td:last-of-type {
      width: 40%;
    }

    th:nth-of-type(2),
    td:nth-of-type(2) {
      width: 20%;
    }

    .gastro-row {
      padding-bottom: 10mm;
    }

    i {
      font-style: italic;
    }

    .pdf-footer {
      font-size: 11px;
    }

    .pdf-footer img {
      max-width: 100%;
    }
  }
`;
